import { h, Fragment } from 'preact'
import { useEffect, useState } from 'preact/compat'
import PropTypes from 'prop-types'
import { useTranslations } from '../../hooks/useTranslations'
import VisaLogo from '../../assets/icons/Visa-Logo.svg'
import MastercardLogo from '../../assets/icons/Mastercard-Logo.svg'
import MaestroLogo from '../../assets/icons/Maestro-Logo.svg'
import AmericanExpressLogo from '../../assets/icons/American-Express-Logo.svg'
import CardDebitTui from '../../assets/icons/card-debit-tui.svg'
import ShowMore from '../Common/ShowMore'
import './styles.scss'

export const paymentsMethods = [
  {
    logo: VisaLogo,
    title: 'Visa',
    type: 'Visa',
  },
  {
    logo: MastercardLogo,
    title: 'Mastercard',
    type: 'MasterCard',
  },
  {
    logo: MaestroLogo,
    title: 'Maestro',
    type: 'Maestro',
  },
  {
    logo: AmericanExpressLogo,
    title: 'American',
    type: 'AmEx',
  },
  {
    logo: CardDebitTui,
    title: 'Tui debit card',
    type: 'GiftCard',
  },
]

const getPaymentInfoMessage = (type, prohibitedCardBrands) => {
  const prohibitedBrandsStr = prohibitedCardBrands?.length ? '' : ' all'
  const TRANSLATIONS = {
    Debit: `We accept${prohibitedBrandsStr} major credit cards.`,
    Credit: `We accept${prohibitedBrandsStr} major debit cards.`,
  }
  const sentence = 'All payment cards are fee-free.'

  const TRANSLATION_KEYS = {
    'We accept major credit and debit cards. All payment cards are fee-free.':
      'MAJOR_CREDIT_DEBIT_CARDS',
    'We accept all major credit and debit cards. All payment cards are fee-free.':
      'ALL_CREDIT_DEBIT_CARDS',
    'We accept all major credit cards. All payment cards are fee-free.':
      'ALL_CREDIT_CARDS',
    'We accept all major debit cards. All payment cards are fee-free.':
      'ALL_DEBIT_CARDS',
    'We accept major credit cards. All payment cards are fee-free.':
      'CREDIT_CARDS',
    'We accept major debit cards. All payment cards are fee-free.':
      'DEBIT_CARDS',
  }

  return TRANSLATION_KEYS[
    (TRANSLATIONS[type] && `${TRANSLATIONS[type]} ${sentence}`) ||
      `We accept${prohibitedBrandsStr} major credit and debit cards. ${sentence}`
  ]
}

const PaymentInfo = ({ prohibitedCardBrands, prohibitedCardType }) => {
  const l10n = useTranslations()

  const [allowedPaymentsMethods, setAllowedPaymentsMethods] =
    useState(paymentsMethods)
  useEffect(() => {
    const paymentsMethodsToDisplay = paymentsMethods.filter(
      el => !prohibitedCardBrands?.includes(el.type),
    )
    setAllowedPaymentsMethods(paymentsMethodsToDisplay)
  }, [])
  const isGiftCardEnabled = !prohibitedCardBrands?.includes('GiftCard')
  return (
    <>
      <div className="allowed-payment-methods-info" data-testid="payment-info">
        <div
          aria-label={l10n.t('Accepted payment methods')}
          className="allowed-payment-methods-info__logo"
        >
          {allowedPaymentsMethods.map(method => (
            <img
              className="logo-image"
              src={method.logo}
              alt={method.title}
              key={method.title}
              data-testid={`${method.title}-icon`}
            />
          ))}
        </div>

        <div
          className="payment-info__message"
          data-testid="payment-info-message"
        >
          {l10n.t(
            getPaymentInfoMessage(prohibitedCardType, prohibitedCardBrands),
          )}
        </div>
      </div>

      {isGiftCardEnabled && (
        <ShowMore
          className="show-more-label  show-more-label__gift-card"
          visibleLabelText={l10n.t('Paying with a gift card')}
          hiddenLabelText={l10n.t('Paying with a gift card')}
          showInMobile={false}
          childrenPosition="bottom"
        >
          <div className="payment-info__gift-card-text">
            {l10n.t('FILL_OUT_FORM_REQUIREMENT')}
          </div>
        </ShowMore>
      )}
    </>
  )
}

PaymentInfo.propTypes = {
  prohibitedCardBrands: PropTypes.array,
  prohibitedCardType: PropTypes.string,
}

export default PaymentInfo
